(() => {
  const dialog = document.querySelector('[data-bkc-welcome]');
  if (!dialog || typeof dialog.showModal !== 'function' || dialog.dataset.ready) return;
  dialog.dataset.ready = 'true';
  const video = dialog.querySelector('video');
  const closeButton = dialog.querySelector('[data-welcome-close]');
  const replayButtons = document.querySelectorAll('[data-welcome-replay]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const sessionKey = 'bastion-welcome-v1';
  let timer;
  let opener;
  let previousOverflow;
  let seen = false;
  try { seen = sessionStorage.getItem(sessionKey) === 'seen'; } catch (_) { seen = true; }
  const close = () => { if (dialog.open) dialog.close(); };
  const finish = () => {
    window.clearTimeout(timer);
    video.pause();
    dialog.classList.remove('is-playing');
    document.documentElement.style.overflow = previousOverflow;
    if (opener && opener.isConnected) opener.focus({ preventScroll: true });
  };
  const open = (trigger) => {
    if (dialog.open) return;
    opener = trigger || null;
    previousOverflow = document.documentElement.style.overflow;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    closeButton.focus({ preventScroll: true });
    dialog.dataset.automatic = trigger ? 'false' : 'true';
    if (!trigger) timer = window.setTimeout(close, 3200);
    if (reducedMotion.matches || navigator.connection?.saveData) return;
    if (!video.src) video.src = video.dataset.src;
    video.currentTime = 0;
    video.muted = true;
    const playback = video.play();
    if (playback) playback.catch(() => dialog.classList.remove('is-playing'));
  };
  closeButton.addEventListener('click', close);
  dialog.addEventListener('close', finish);
  video.addEventListener('playing', () => { if (dialog.open) dialog.classList.add('is-playing'); });
  video.addEventListener('error', close);
  reducedMotion.addEventListener('change', () => { if (reducedMotion.matches) close(); });
  window.addEventListener('pagehide', close);
  replayButtons.forEach((button) => {
    button.hidden = false;
    button.addEventListener('click', () => open(button));
  });
  if (seen || reducedMotion.matches || navigator.connection?.saveData || location.hash || window.scrollY > 0 || dialog.dataset.auto !== 'true' || dialog.dataset.designMode === 'true') return;
  try { sessionStorage.setItem(sessionKey, 'seen'); } catch (_) { return; }
  open();
})();
